import GridTemplate from '@/ft-vue-core/components/canvas/GridTemplate'
import Stage from '@/ft-vue-core/components/canvas/Stage'
import Group from '@/ft-vue-core/components/canvas/Group'
import DrawBox from '@/ft-vue-core/components/canvas/DrawBox'
import DrawCircle from '@/ft-vue-core/components/canvas/DrawCircle'
import DrawImage from '@/ft-vue-core/components/canvas/DrawImage'
import DrawLabel from '@/ft-vue-core/components/canvas/DrawLabel'
import DrawText from '@/ft-vue-core/components/canvas/DrawText'
import DrawLine from '@/ft-vue-core/components/canvas/DrawLine'
import DrawArc from '@/ft-vue-core/components/canvas/DrawArc'
function* getUniqueName (prefix = 'element') {
  for (let i = 1; ; i++) yield prefix.concat('-', i)
}
export default {
  components: {
    GridTemplate,
    Stage,
    Group,
    DrawBox,
    DrawCircle,
    DrawImage,
    DrawLabel,
    DrawText,
    DrawLine,
    DrawArc,
  },
  data () {
    return {
      uniqueNamePrefix: undefined,
      nameGenerator: getUniqueName(),
    }
  },
  watch: {
    uniqueNamePrefix (newVal) {
      this.nameGenerator = getUniqueName(newVal)
    }
  },
  methods: {
    getUniqueName () {
      return this.nameGenerator.next()
    },
  }
}